import script from "./Overlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./Overlay.vue?vue&type=script&setup=true&lang=ts"

import "./Overlay.vue?vue&type=style&index=0&id=79e80ad4&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79e80ad4"]])

export default __exports__